(function() { window.GUID_c06eacb6_de34_48d4_ad7f_2bf2672f96e1 = { getGuid: function() { return "c06eacb6-de34-48d4-ad7f-2bf2672f96e1"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let SnackbarType;
        (function (SnackbarType) {
            SnackbarType[SnackbarType["Danger"] = 0] = "Danger";
            SnackbarType[SnackbarType["Info"] = 1] = "Info";
            SnackbarType[SnackbarType["Success"] = 2] = "Success";
            SnackbarType[SnackbarType["Warning"] = 3] = "Warning";
        })(SnackbarType = Enumeration.SnackbarType || (Enumeration.SnackbarType = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=SnackbarType.pre.js.map
